import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ORingFailureComponent } from './o-ring-failure.component';

const routes: Routes = [
  {
    path: '',
    component: ORingFailureComponent,
    data: {
      meta: {
        title: 'O-Ring Failure & Troubleshooting Guide | Marco Sealing Solutions',
        description: 'Learn how to troubleshooot why o-ring leak failure occurs and what solutions are available using this informative reference guide from Marco Rubber.'
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class ORingFailureRoutingModule { }
